<template>
  <span
    :class="colorClass"
    class="px-1.5 py-0.5 text-[10px] font-semibold rounded-full whitespace-nowrap inline-block leading-none"
  >{{ label || level }}</span>
</template>

<script>
const LEVEL_COLORS = {
  security: 'bg-red-100 text-red-700',
  admin: 'bg-blue-100 text-blue-700',
  manager_viewer: 'bg-indigo-100 text-indigo-700',
  standard: 'bg-green-100 text-green-700',
  restricted: 'bg-amber-100 text-amber-700',
  readonly: 'bg-gray-200 text-gray-600',
  portal: 'bg-teal-100 text-teal-700',
};

export default {
  props: {
    level: { type: String, required: true },
    label: { type: String, default: '' },
  },
  computed: {
    colorClass() {
      return LEVEL_COLORS[this.level] || 'bg-gray-100 text-gray-600';
    },
  },
};
</script>
